import { Component, NgModule, Output, Input, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ItemClickEvent } from 'devextreme/ui/tree_view';
import { DxTreeViewModule, DxTreeViewComponent } from 'devextreme-angular/ui/tree-view';
import { navigation } from '../../../app-navigation';

import * as events from 'devextreme/events';
import { formatMessage } from 'devextreme/localization';
import { NotifyHelper } from 'src/app/core/utils/notify-helper.util';
import { LocalizationHelper } from 'src/app/core/utils/localization-helper.util';
import {AuthService} from "../../../core/services/auth.service";
import {NavigationItem} from "../../../core/models/navigation-item.model";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-side-navigation-menu',
  templateUrl: './side-navigation-menu.component.html',
  styleUrls: ['./side-navigation-menu.component.scss']
})
export class SideNavigationMenuComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DxTreeViewComponent, { static: true })
  menu!: DxTreeViewComponent;

  @Output()
  selectedItemChanged = new EventEmitter<ItemClickEvent>();

  @Output()
  openMenu = new EventEmitter<any>();

  private _selectedItem!: String;
  @Input()
  set selectedItem(value: String) {
    this._selectedItem = value;
    if (!this.menu.instance) {
      return;
    }

    this.menu.instance.selectItem(value);
  }

  private _items: NavigationItem[] = [];
  get items(): any[] {
    if(this._items.length == 0) {
      this._items = this.buildMenu(navigation);
    }

    return this._items;
  }

  private buildMenu(items: NavigationItem[]) : NavigationItem[] {
    return items.filter(item => this.filterMenuItem(item)).map((item) => {

      this.setMenuItem(item);

      if(item.items) {
        item.items = this.buildMenu(item.items);
      }

      return { ...item, expanded: !this._compactMode }
    });
  }

  private filterMenuItem(item: NavigationItem) : boolean {
    if(item.permissions == null) {
      return true;
    }

    for(let permission in item.permissions) {
      if(this.authService.hasPermission(item.permissions[permission])) {
        return true;
      }
    }

    return false;
  }

  private setMenuItem(item: any) {
    if (item.path && !(/^\//.test(item.path))) {
      item.path = `/${item.path}`;
    }
    item.text = LocalizationHelper.translate(item.text);
  }

  private _compactMode = false;
  @Input()
  get compactMode() {
    return this._compactMode;
  }
  set compactMode(val) {
    this._compactMode = val;

    if (!this.menu.instance) {
      return;
    }

    if (val) {
      this.menu.instance.collapseAll();
    } else {
      this.menu.instance.expandItem(this._selectedItem);
    }
  }

  constructor(private elementRef: ElementRef, private authService: AuthService) {
  }

  onItemClick(event: ItemClickEvent) {
    this.selectedItemChanged.emit(event);
  }

  ngAfterViewInit() {
    events.on(this.elementRef.nativeElement, 'dxclick', (e: Event) => {
      this.openMenu.next(e);
    });
  }

  ngOnDestroy() {
    events.off(this.elementRef.nativeElement, 'dxclick');
  }
}

@NgModule({
  imports: [DxTreeViewModule, RouterLink],
  declarations: [SideNavigationMenuComponent],
  exports: [SideNavigationMenuComponent]
})
export class SideNavigationMenuModule { }
